import React from 'react';
import { Button } from '@mui/material';
import { ListAlt as ListAltIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import type { GranjaMovimientoTipo } from '../../services/granjaService';

type Props = {
  tipo?: GranjaMovimientoTipo;
  size?: 'small' | 'medium' | 'large';
};

/** Acceso al listado de movimientos Granja, con filtro de tipo opcional. */
const GranjaMovimientosLinkButton: React.FC<Props> = ({ tipo, size = 'small' }) => {
  const navigate = useNavigate();
  const path = tipo ? `/granja/movimientos?tipo=${encodeURIComponent(tipo)}` : '/granja/movimientos';
  return (
    <Button
      variant="outlined"
      size={size}
      startIcon={<ListAltIcon />}
      onClick={() => navigate(path)}
      sx={{ textTransform: 'none', fontWeight: 600 }}
    >
      Ver movimientos
    </Button>
  );
};

export default GranjaMovimientosLinkButton;
